import React, { useCallback } from "react";
import { useWorkspaceRuleGroupsList } from "@api/rules.api";
import { useScope } from "@state/scopeContext.lib";
import { RuleGroupType } from "@common/types/transactionRule";
import { useCreateRuleGroup } from "@api/ruleGroups.api";
import { RuleGroupForm, RuleGroupSchema } from "./RuleGroupForm";

interface CreateRuleGroupModalProps {
    onHide: () => void;
    type: RuleGroupType;
}

export const CreateRuleGroupModal: React.FC<CreateRuleGroupModalProps> = ({
    onHide,
    type,
}) => {
    const { workspaceId } = useScope();
    const createMutation = useCreateRuleGroup(onHide);
    const ruleGroupsList = useWorkspaceRuleGroupsList();

    const onSubmit = useCallback(
        (ruleGroupData: RuleGroupSchema) => {
            const newOrder =
                (ruleGroupsList.data ?? []).filter((g) => g.type === type)
                    .length + 1;

            return createMutation.mutateAsync({
                workspaceId: workspaceId ?? "",
                ruleGroup: {
                    name: ruleGroupData.name,
                    icon:
                        type === RuleGroupType.ACCOUNTING
                            ? "bank"
                            : "briefcase",
                    order: newOrder,
                    type,
                },
            });
        },
        [createMutation, workspaceId, ruleGroupsList.data, type],
    );

    return (
        <RuleGroupForm
            onHide={onHide}
            isPending={createMutation.isPending}
            onSubmitRuleGroup={onSubmit}
            type={type}
        />
    );
};
